import { render, staticRenderFns } from "./checkRegistration.vue?vue&type=template&id=ac1892de"
import script from "./checkRegistration.vue?vue&type=script&lang=js"
export * from "./checkRegistration.vue?vue&type=script&lang=js"
import style0 from "./checkRegistration.vue?vue&type=style&index=0&id=ac1892de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports